function sortByField(field, locale) {
  return (a, b) => {
    const options = { numeric: true, sensitivity: 'base', caseFirst: 'upper' };
    if (a[field] && b[field]) {
      // Not all browsers support the extended options for localeCompare(). As such, we
      // wrap the extended version in a try/catch and just fall-back to using the simple
      // version. In this case, we're going to use the "numeric" and sensitivity option, which gets the
      // browser to treat embedded numbers AS NUMBERS and only strings that differ in base letters
      // compare as unequal, which allows for a more "natural sort" behavior.
      try {
        return a[field].localeCompare(b[field], locale, options);
      } catch (error) {
        console.warn('Extended localeCompare() not supported in this browser.');
        return a[field].localeCompare(b[field]);
      }
    }
  };
}

function sortStrings(locale) {
  return (a, b) => {
    const options = { sensitivity: 'base', caseFirst: 'upper' };
    try {
      return a.localeCompare(b, locale, options);
    } catch (error) {
      console.warn('Extended localeCompare() not supported in this browser.');
      return a.localeCompare(b);
    }
  };
}

function trimAndStrip(array) {
  return array.map(v => v && v.trim()).filter(v => v?.length);
}

function getBase64FileSize(base64String) {
  return base64String.length * (3 / 4) - 2;
}

export { getBase64FileSize, sortByField, sortStrings, trimAndStrip };
